// ============================================================
// Quick Links Scroll Hint (Mobile Only)
// After 3 seconds, nudges the bar right then back to hint
// that it is scrollable. Mobile only, respects reduced-motion.
// ============================================================
document.addEventListener('DOMContentLoaded', function () {
  // Only run on mobile
  if (!window.matchMedia('(max-width: 767px)').matches) return;

  // Respect reduced-motion preference
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  setTimeout(function () {
    var sliders = document.querySelectorAll('.quick-links-list.grid');
    sliders.forEach(function (slider) {
      // Only animate if there's actually overflow to scroll
      if (slider.scrollWidth <= slider.clientWidth) return;

      var peekAmount = 48; // px to peek right

      // Slide right to hint at more content
      slider.scrollTo({ left: peekAmount, behavior: 'smooth' });

      // Slide back after the forward motion completes
      setTimeout(function () {
        slider.scrollTo({ left: 0, behavior: 'smooth' });
      }, 600);
    });
  }, 3000);
});

/*
document.addEventListener('DOMContentLoaded', function() {
    const mainContentRedirect = document.getElementById('MainBodyContent');
    const cartDrawerRedirectOpen = document.querySelector('cart-drawer');
    const restrictedPageURL = '/cart';
    const previousPageUrl = document.referrer;

    // After Redirect Function
    function afterRedirect() {
        mainContentRedirect.classList.add('overflow-hidden');
        cartDrawerRedirectOpen.classList.add('active');
    }

    // Redirect from restrictedPageURL
    if (window.location.href.includes(restrictedPageURL)) {
        sessionStorage.setItem('afterRedirectAction', 'true');
        window.location.href = '/index?cart=1';
    }

    // Check if redirect ran
    if (sessionStorage.getItem('afterRedirectAction') === 'true') {
        sessionStorage.removeItem('afterRedirectAction');
    }

    // Chack Previous Page URL
    if (previousPageUrl.includes(restrictedPageURL)) {
        console.log("The user came from: Cart Page");
        setTimeout(() => {
            afterRedirect();
        }, 500);
    }
});
*/